<script>
	/* Stores */
	import { headerTitle, alt } from '../store.js';
	import { fly }    from 'svelte/transition';
	
	/* Code */
	export let title = '';
	export let classe = '';
	export let setPageTitle = true;
	
	export let buttons = [
		{
			href: '/contato',
			name: 'Contato',
			icon: '<i class="fal fa-headset"></i>',
		}
	];

	jQuery('html, body').animate({
		scrollTop: jQuery('.header-section').offsetTop + jQuery('header').innerHeight()
	}, 200);	
</script>

<svelte:head>
{#if setPageTitle}
<title>{title} {$headerTitle}</title>
{/if}
</svelte:head>

<div class="header-section {classe}">
    <div class="container">
		<div class="itens">
			<div class="item">
				<h1 in:fly="{{ y: 50, duration: 1500 }}">{@html title}<span class="text-seo"> - {$alt}</span></h1>
			</div>
			{#if buttons.length > 0}
			<div class="item">
				<div class="buttons">
					{#each buttons as buttom}
					{#if buttom.onClick}
						<a href="{buttom.href}" class="btn btn-primary" title="Ir para {buttom.name}" on:click="{buttom.onClick}">
							{@html buttom.icon} {buttom.name}
						</a>
					{:else}
						<a href="{buttom.href}" class="btn btn-primary" title="Ir para {buttom.name}">
							{@html buttom.icon} {buttom.name}
						</a>
					{/if}
					{/each}
				</div>
			</div>
			{/if}
			<slot></slot>
		</div>
    </div>	
</div>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'
.header-section
	background-color: $color-bg
	margin-bottom: 25px
	padding: 20px 0
	background-size: 20%
	background-position: center bottom
	background-repeat-y: no-repeat
	.itens 
		.item
			text-align: center
			h1 
				color: $color-primary
				font-size: $font-title
				margin-bottom: 0
				font-weight: bold
			.buttons
				display: flex
				text-align: center
				align-items: center
				justify-content: center
				flex-wrap: wrap
				.btn
					margin: 5px

+media-breakpoint-up(lg)
	.header-section .itens
		display: flex
		align-items: center
		justify-content: space-between
		.item
			text-align: center
		.buttons 
			margin: 0

</style>